// extracted by mini-css-extract-plugin
export default {"container":"_3kuT7W0kXQSTL3ZFvrUow_","outlined":"_9Ss8oJEtslcb8qiZdKhEL","name":"CYdG76WYjYc1U7X3r4oJi","icon":"_25UVgZFqhthXlrKggeKEBC"};